import type { JSX, PropsWithChildren } from 'react';

import { EditOutlined } from '@ant-design/icons';
import { cx } from '@emotion/css';
import { Col, Row } from 'antd';
import { Spacing } from 'src/styles';

import { MButton } from '../FormComponents/MButton/MButton';
import { MTooltip } from '../MTooltip/MTooltip';

import * as Styles from './MFormSection.styles';

export interface MFormSectionProps {
  title?: string;
  onEdit?: () => void;
  isEditable: boolean;
  isEditMode: boolean;
  tooltip?: {
    type: 'modal' | 'popover';
    icon?: 'info' | 'question';
    title?: string;
    label?: string;
    content: string | JSX.Element;
  };
  className?: string;
  testId?: string;
}

export const MFormSection = ({
  title,
  onEdit,
  isEditable,
  isEditMode,
  tooltip,
  className = '',
  children,
  testId,
}: PropsWithChildren<MFormSectionProps>) => {
  return (
    <div className={cx(Styles.section, className)}>
      <Row className={Spacing.mb32}>
        <Col span={24} className={Styles.header(Boolean(title))}>
          {title && (
            <Col className={Styles.title} data-testid={testId + '-title'}>
              {title}
            </Col>
          )}
          <Col>
            {isEditable && !isEditMode && (
              <MButton onClick={onEdit} type='tertiary' testId={testId + '-edit-button'}>
                Edit <EditOutlined />
              </MButton>
            )}
          </Col>
        </Col>
        {tooltip && (
          <Col span={24}>
            <MTooltip
              type={tooltip.type}
              icon={tooltip.icon}
              title={tooltip.title}
              label={tooltip.label}
              testId={testId}>
              {tooltip.content}
            </MTooltip>
          </Col>
        )}
      </Row>
      <Row>{children}</Row>
    </div>
  );
};
